import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const CancelIcon = createIcon({
  displayName: 'CancelIcon',
  path: [
    <path
      d='M16.405 18.554a1.518 1.518 0 0 0 2.15 0c.578-.594.578-1.57 0-2.149L14.148 12l4.405-4.405a1.518 1.518 0 0 0 0-2.15 1.518 1.518 0 0 0-2.149 0L12 9.852 7.595 5.446a1.518 1.518 0 0 0-2.15 0 1.518 1.518 0 0 0 0 2.149L9.852 12l-4.405 4.405a1.518 1.518 0 0 0 0 2.15 1.518 1.518 0 0 0 2.149 0L12 14.148l4.405 4.405Z'
      fill={'currentColor'}
    />
  ],
  defaultProps: defaultProps
})
